var $2d3d7fae96724346$exports = {};
document.querySelector('.shadow-bg').addEventListener('click', function(e) {
    document.querySelector('.shadow-bg').classList.remove('active');
    document.querySelector('.modal').classList.remove('active');
});
document.querySelector('.close-popup').addEventListener('click', function(e) {
    document.querySelector('.modal').classList.remove('active');
    document.querySelector('.shadow-bg').classList.remove('active');
});
function $2d3d7fae96724346$var$submitForm(e) {
    e.preventDefault();
    const api = e.target.action;
    const formData = [
        ...new FormData(e.target).entries()
    ];
    let ycid = null;
    const ubtcuid = document.cookie.split('; ').find((row)=>row.startsWith('_ubtcuid'))?.split('=')[1];
    const domainUserId = window.Snowplow?.getTrackerCf().getDomainUserId();
    ym(49633516, 'getClientID', (clientID)=>{
        ycid = clientID;
    });
    const dataObject = formData.reduce((acc, [key, val])=>({
            ...acc,
            [key]: val
        }), {
        urlUtm: document.location.href,
        ycid: ycid,
        ubtcuid: ubtcuid,
        domainUserId: domainUserId
    });
    Object.keys(dataObject).forEach((key)=>{
        dataObject[key] = dataObject[key]?.toLowerCase()?.replaceAll('>', '&#62;').replaceAll('<', '&#60;').replaceAll('&', '&#38;').replaceAll('eval', '&#101;&#118;&#97;&#108;');
    });
    document.querySelector('.modal').classList.add('active');
    document.querySelector('.shadow-bg').classList.add('active');
    fetch(api, {
        method: 'post',
        body: JSON.stringify(dataObject),
        headers: {
            "Content-Type": "application/json"
        }
    }).then(()=>{
        window.dataLayer = window.dataLayer || [];
        ym(49633516, 'reachGoal', document.location.host === 'uxfeedback.ru' ? 'subscription_book_form_send' : 'test_subscription_book_form_send');
        this.reset();
        window.localStorage.setItem('isSubscribedToBook', true);
    });
}
document.querySelector('.bookSubscriptionForm').addEventListener('submit', $2d3d7fae96724346$var$submitForm);


//# sourceMappingURL=books.9b65e153.js.map
